import CircularRectTextButton, { CircularRectTextButtonProps } from "./CircularRectTextButton";
import { themeColors } from "@/utils/themeColors";

export const FilledTextButton = ({ children, sx, ...btnProps }: CircularRectTextButtonProps) => {
    return (
        <CircularRectTextButton
            sx={{
                background: themeColors.neutralWhite,
                color: themeColors.neutralBlack,
                fontSize: "1.4rem",
                width: "auto",
                padding: "0.8rem 1.6rem",
                height: "4rem",
                "&:hover": {
                    background: themeColors.neutralBlack,
                    color: themeColors.neutralWhite,
                },
                "&:active": {
                    transform: "scale(0.99)",
                },
                ...sx,
            }}
            {...btnProps}>
            {children}
        </CircularRectTextButton>
    );
};

export default FilledTextButton;
